import React, { Component } from 'react';
// import DevTools from "mobx-react-devtools";
import { Router, Route, Switch } from 'react-router-dom'

import {history} from '../history';

import styled from 'styled-components';
import {Manager} from "../game/manager.js";
// import { comm } from '../comm';
import { store } from '../stores/mainStore';
// import { TextGame } from './TextGame';

import { toJS, observable } from 'mobx';
import { Game } from './Game';
import {Lobby} from './Lobby';
import { TutorialPreload } from './TutorialPreload';
import { observer } from 'mobx-react';
import { PlayerProfile } from './PlayerProfile';

import { Splash } from './Splash';

import {debounce, max} from 'lodash';
import { Overlays } from './Overlays';
import { User } from '../stores/models/User';
import { PhaserGame } from './PhaserGame';
import { AnimatePresence} from "framer-motion";
import { Achievements } from './Achievements';
import { ProductStore } from './ProductStore';
import { ToastBanners } from './ToastBanners';
import { Sprite } from './Sprite';
import { TopBar } from './TopBar';
import { BottomBar } from './BottomBar';
import { integration } from '../integration';


window.router = history;
window.toJS = toJS;
//import color from 'color';

// const Search = styled.div`
// 	color: white;
// 	font-size: 16px;
// `

window.gameTimeouts = [];
window.gameSetTimeout = function(f, delay, ...rest){
	const id = setTimeout(f, delay, ...rest);
	window.gameTimeouts.push(id);
	return id;
}

const AppBody = styled.div`
	height: 100vh;
	width: 100vw;
	background: ${store.isHardRock === true ? 'rgb(19,0,53)' : 'rgb(63, 87, 177)'}; 
	background: ${store.isHardRock === true ? 'linear-gradient(0deg, rgba(19,0,53,1) 0%, rgba(45,18,92,1) 50%, rgba(108,60,195,1) 100%)' : 'linear-gradient(0deg, rgba(63, 87, 177, 1) 0%, rgba(49, 108, 205, 1) 100%)'};
`

const Modals = styled.div`
	width: 100%;
	z-index: 1000;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	pointer-events: none;
	& > *{
		pointer-events: initial;
	}
`

// const Debug = styled.div`
// 	min-height: 1em;
// 	max-height: 200px;
// 	overflow: auto;
// 	background-color: rgba(255,255,255,0.75);
// 	opacity: 0.75;
// 	text-shadow: none;
// 	color: black;
// 	position: fixed;
// 	bottom: 0;
// 	left: 0;
// 	width: 100vw;
// 	pointer-events: none;
// 	display: flex;
// 	flex-direction: column;
// 	justify-content: flex-end;
// 	z-index: 1000000;
// 	& > div {
// 		padding: 2px;
// 		&:nth-child(even) {
// 			color: red;
// 		}
// 	}
// `

const Screen = styled.div`
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: column;
`

const MainWrap = styled.div`
	flex-grow: 1;
	overflow: hidden;
	position: relative;
`

@observer
export class Main extends Component {

	@observable windowSizeStable = false;

	@observable online = true;
	@observable restartWhenOnline = false;

	constructor(props){
		super(props);

		window.manager = null;
		window.manager = new Manager();

		//push location into the memory history
		history.push(window.location.pathname);

		store.user = new User(store);
		store.user.login()
		.then(() => {
			//when login is complete.
			store.getBotListData()
			.then(() => {

				store.createMatch(store.getRandomBotId())
				.then(response => {
					history.push(`/game/${response.Match.Id}/play`);
				});
			})
		});

		store.getTosVersion();

		window.addEventListener('resize', this.waitForSize);
		this.waitForSize();
		window.addEventListener('online', () => {
			this.online = true;
			if(this.restartWhenOnline){
				window.restartWebview();
			}
		});
		window.addEventListener('offline', () => {
			integration.postAnalyticsEvent('loading_network_error_screen','user_experience');
			this.online = false;
		});
	}

	waitForSize = debounce(() => {
		if(window.innerHeight > 300 && window.innerWidth > 300){
			this.windowSizeStable = true;
			const height = max([320,window.innerHeight]);
			const width = max([320, window.innerWidth]);
			// console.log("WINDOW: "+window.innerWidth+", "+window.innerHeight);
			store.aspectRatio = width / height;
		} else {
			this.waitForSize();
		}
	}, 2500);

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	render() {
		var showSplash = store.firstTimeRules || (!store.preventReturnToSplash && (store.preloading || !store.user.isReady || !store.tosIsAccepted || (store.user.hasSeenOrSkippedTutorial && store.user.mustLogin)));

		console.log('user is logged in', store.user.guest.serverData.AnonymousUsername);

		const networkOfflineImg = (
			<Sprite onClick={() => {
				integration.postAnalyticsEvent(`loading_network_error_retry`,'user_experience');
				this.restartWhenOnline = true;
			}} localize w={80} sprite="popup_connection_error_with_buttons.png"/>
		);

		const generalErrorImg = (
			<Sprite onClick={window.restartWebview} localize w={80} sprite="popup_server_error_with_buttons.png"/>
		);

		return (
			<Router history={history}>
				<AppBody
					onTouchStart={() => {
						store.globalDebug = 'touch start';
					}}
					onTouchEnd={() => {
						store.globalDebug = 'touch end';
					}}
					className={store.aspectName}
				>
					{showSplash || (this.online === false && this.restartWhenOnline) ? (
						<Splash tos={store.currentTosId}/>
					) : (
						<Screen>
							{(!store.topBar.hide || (store.activeMatch !== null && !store.tutorialMode)) && <TopBar/>}
							{/* <Search>{window.location.search}</Search> */}
							{/* <DevTools/> */}
							<MainWrap key={store.user.guest.serverData.AnonymousUsername}>
								<Route render={(route) => {
									console.log('route: ',route);
									return (
										<AnimatePresence key="pages">
											<Switch location={route.location}>
												<Route key="Lobby" exact path={'/'} component={Lobby}/>
											</Switch>
										</AnimatePresence>
									);
								}}/>
								<Route key="Game" exact path={'/game/:gameId/:mode'} component={Game}/>
								<Modals>
									{store.showAchievements && <Achievements modal />}
									{store.showProductStore && store.productStoreReady && <ProductStore modal />}
									{store.showProfile && <PlayerProfile/>}
								</Modals>
								<ToastBanners/>
							</MainWrap>
							<Overlays key="overlays"/>
							{store.showBottomNav && <BottomBar/>}
						</Screen>
					)}
					{this.windowSizeStable && (
					<div key="phaserWrap" style={{
						display: store.activeMatch ? 'block' : 'none',
						zIndex: store.activeMatch ? 100 : -100,
						position: 'absolute', height: '100%', width: '100%',
						top: store.activeMatch ? 0 : 10000, left: 0
					}}>
						<PhaserGame key={`phaser-${store.phaserInstanceIndex}`}/>
					</div>)}

					{/* <Debug>{store.errorMessage}</Debug> */}
					{!store.user.hasSeenOrSkippedTutorial && <TutorialPreload/>}
					{!this.online && <Error>{networkOfflineImg}</Error>}
					{!!store.errorMessage && <Error>{generalErrorImg}</Error>}
				</AppBody>
			</Router>
		);
	}
}

const Error = styled.div`
	z-index: 10000;
	position: absolute;
	width: 100%;
	text-align: center;
	top: 15vw;
`
